import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  IconButton,
  Icon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListSubheader,
  Button,
  TextField,
} from '@material-ui/core';
import { categories } from './icons.json';

class IconPicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      displayIconPicker: false,
      search: '',
    };
  }

  getIconClickHandler = (id) => () => {
    this.handleIconChange(id);
  }

  handleIconChange = (icon) => {
    this.props.onIconChange(icon);
    this.handleIconPickerClose();
  }

  handleIconPickerClose = () => {
    this.setState({ displayIconPicker: false });
  }

  handleIconPickerOpen = () => {
    this.setState({ displayIconPicker: true });
  }

  handleSearchChange = (e) => {
    this.setState({ search: e.target.value });
  }

  render() {
    const { icon } = this.props;
    const {
      search,
      displayIconPicker,
    } = this.state;
    return (
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }}>
          <Typography variant="subtitle1" style={{ lineHeight: '48px' }}>
            Icon
          </Typography>
        </div>
        <IconButton onClick={this.handleIconPickerOpen}>
          <Icon>{icon}</Icon>
        </IconButton>
        <Dialog
          open={displayIconPicker}
          onClose={this.handleIconPickerClose}
        >
          <DialogTitle>Select an Icon</DialogTitle>
          <DialogContent>
            <TextField
              id="search-icon"
              label="Search"
              value={search}
              onChange={this.handleSearchChange}
              fullWidth
              margin="normal"
              variant="outlined"
              helperText="*typing may be delayed due to icon load time"
            />
            <List>
              {
                categories.map((category) => (
                  <li key={`category-${category.name}`}>
                    <ul
                      style={{
                        backgroundColor: 'white',
                        padding: 0,
                      }}
                    >
                      <ListSubheader>{category.name.replace('_', ' ').toUpperCase()}</ListSubheader>
                      {
                        category
                          .icons
                          .filter((i) => (search.length === 0 || i.id.indexOf(search) >= 0))
                          .map((iconOption) => (
                            <IconButton
                              key={`icon-${iconOption.id}`}
                              onClick={this.getIconClickHandler(iconOption.id)}
                              className="icon"
                            >
                              <Icon>{iconOption.id}</Icon>
                            </IconButton>
                          ))
                      }
                    </ul>
                  </li>
                ))
              }
            </List>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleIconPickerClose} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

IconPicker.propTypes = {
  icon: PropTypes.string,
  onIconChange: PropTypes.func,
};

IconPicker.defaultProps = {
  onIconChange: () => {},
  icon: '',
};

export default IconPicker;
